import React, { Component } from 'react';

import Jumbotron from 'react-bootstrap/Jumbotron';

class DriverSettlementsPage extends Component {
    render() {
        return (
            <Jumbotron>
                <h1>Settlements</h1>
                <hr /><br />
                <p>Do some stuff</p>
            </Jumbotron>
        );
    }
}

export default DriverSettlementsPage;